import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { applicationNotesKey, errorMessage } from '@features/applicationNotes';
import { applicationNotesRoute } from '@features/applicationNotes/api/constants';
import axiosInstance from '@server/axiosInstance';

type useDeleteEnterpriseApplicationNoteProps = {
  applicationId: number;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteEnterpriseApplicationNote = ({
  applicationId,
  setErrorText = () => { },
}: useDeleteEnterpriseApplicationNoteProps) => {
  const client = useQueryClient();
  const { mutate: deleteNote, isLoading: isDeleteNoteLoading } = useMutation({
    mutationFn: (variables: { company_id: number, application_note_id: number }) =>
      axiosInstance
        .delete(applicationNotesRoute, { data: variables })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
      }
      client.invalidateQueries([applicationNotesKey, applicationId]);
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    deleteNote,
    isDeleteNoteLoading,
  };
};
